import moment from 'moment-timezone';

import { expressDeliveryConstants } from '../../constant/express.delivery.constant';

const { BRT_TIMEZONE } = expressDeliveryConstants;

// O horário da entrega vem do próprio prazo que a API calcula e grava (hoje, 23h de Brasília). A tela
// não guarda horário próprio, para não prometer um horário diferente do que o sistema grava.
const formatDeliveryHour = (localDueDate) =>
    localDueDate.minutes() ? localDueDate.format('H[h]mm') : localDueDate.format('H[h]');

const describeExpressDelivery = (newDueDate, now = moment()) => {

    if (!newDueDate)
        return null;

    const localDueDate = moment.tz(newDueDate, BRT_TIMEZONE);
    if (!localDueDate.isValid())
        return null;

    const isToday = localDueDate.isSame(moment.tz(now, BRT_TIMEZONE), 'day');

    return `Receba ${isToday ? 'hoje ' : ''}até as ${formatDeliveryHour(localDueDate)} · ${localDueDate.format('DD [de] MMMM')}`;
};

export default {
    describeExpressDelivery,
};
